import axios from '../api/axiosInstance';

const config = (options = {}) => ({ ...options, headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });
const waistApi = {
  get: (url, options) => axios.get(url, config(options)),
  post: (url, data) => axios.post(url, data, config()),
  put: (url, data) => axios.put(url, data, config()),
  delete: url => axios.delete(url, config()),
};
export default waistApi;
